import { createSlice } from '@reduxjs/toolkit';

const initialState = null;

export const templatesSlice = createSlice({
	name: 'templates',
	initialState,
	reducers: {
		setTemplatesState: (state, action) => {
			//null is not a valid
			if (!action.payload) {
				return initialState;
			} else {
				return action.payload;
			}
		},
		updateTemplatesState: (state, action) => {
			//null is not a valid
			if (!action.payload) {
				return [...state];
			} else {
				const incomingItems = Array.isArray(action.payload)
					? action.payload
					: [action.payload];

				if (!Array.isArray(state)) {
					return [...incomingItems];
				} else {
					const incomingById = new Map(
						incomingItems
							.filter((item) => item && item._id)
							.map((item) => [item._id, item]),
					);

					const nextState = state.map((item) => {
						if (!item || !item._id) {
							return item;
						}

						return incomingById.has(item._id)
							? incomingById.get(item._id)
							: item;
					});

					const existingIds = new Set(
						state.filter((item) => item && item._id).map((item) => item._id),
					);

					incomingItems.forEach((item) => {
						if (!item) {
							return;
						}

						if (!item._id || !existingIds.has(item._id)) {
							nextState.push(item);
						}
					});

					return nextState;
				}
			}
		},
		resetTemplatesState: (state, action) => {
			return initialState;
			// console.log('Project Remove', action.payload)
		},
	},
});

// Action creators are generated for each case reducer function
export const { setTemplatesState, updateTemplatesState, resetTemplatesState } =
	templatesSlice.actions;

export const getTemplatesState = (state) => state.templates;
export const getDefaultTemplatesState = () => initialState;

export default templatesSlice.reducer;
